import {AfterViewInit, Component, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ReplicationTableService} from "@data/system/database/replication.table.service";
import {Util} from "@data/util/util";
import {pageContext, tableColumns} from "@pages/system/database/replication-table/replication-table.component.ds";
import {TableBaseComponent} from "@pages/table.base.component";
import {AgGridService} from "@shared/services/ag-grid.service";
import {ReplicationTable} from "@data/interefaces/itf_system.interfaces";
import {FirstDataRenderedEvent, SelectionColumnDef} from "@ag-grid-community/core";

@Component({
  selector: 'app-replication-table',
  templateUrl: './replication-table.component.html',
  styleUrls: ['./replication-table.component.scss'],
  providers: [AgGridService]
})

export class ReplicationTableComponent extends TableBaseComponent implements AfterViewInit {

  rowData: ReplicationTable[] = [];
  auxLinks: Map<string, string>;
  showSkeleton: boolean = true;
  refreshComplete: boolean = true;
  isFilterActive: boolean = false;
  @ViewChild('footerActionButtonPanel') footerActionButtonPanel: TemplateRef<any> | undefined;

  protected readonly util = Util;
  protected readonly pageContext = pageContext;
  protected override readonly tableColumns = tableColumns;

  constructor(private _activatedRoute: ActivatedRoute, private _replicationTableService: ReplicationTableService) {
    super();
    this.auxLinks = new Map([['/home/welcome', 'Home']]);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initiatePageState(this._activatedRoute.snapshot.queryParamMap);
    this.loadPageData().catch(error => this.displayNotificationMessage('error', JSON.stringify(error)));
    this.updatePageContext();
  }

  ngAfterViewInit() {
  }

  async loadPageData() {
    this.refreshComplete = false;
    this.displayProgressBar(true);
    await this._replicationTableService.getReplicationTables().then(result => {
      this.rowData = result;
    }).catch(error => this.displayNotificationMessage('error', JSON.stringify(error))
    ).finally(() => {
        this.displayProgressBar(false);
        this.refreshComplete = true;
      }
    );
  }

  async refreshView() {
    await this.loadPageData().catch(error => this.displayNotificationMessage('error', JSON.stringify(error)));
  }

  protected override updatePageContext(updateContextUrl: boolean = true): void {
    this.isFilterActive = Util.checkFilterActive(this.pageContext);
    if (updateContextUrl) {
      this.updateToPageContextUrl();
    }
  }

  protected override getSelectionColumnDef(): SelectionColumnDef {
    return {};
  }

  protected override getTableFooterActionButtonPanel(): TemplateRef<any> | undefined {
    return this.footerActionButtonPanel
  }

  protected override onFirstDataRendered(event: FirstDataRenderedEvent<any>) {
    super.onFirstDataRendered(event);
    event.api.autoSizeAllColumns();
  }
}
